/**
 * DataAgentStatusBadge Component
 *
 * Visual indicator for data agent status.
 */

import React from 'react';
import type { DataAgentStatus } from '../../../types/data-agent.types';

interface DataAgentStatusBadgeProps {
  status: DataAgentStatus;
  showPulse?: boolean;
}

const statusConfig: Record<DataAgentStatus, { label: string; className: string; pulse: boolean }> = {
  online: {
    label: 'Online',
    className: 'bg-green-100 text-green-800 border-green-200',
    pulse: true,
  },
  offline: {
    label: 'Offline',
    className: 'bg-red-100 text-red-800 border-red-200',
    pulse: false,
  },
  unknown: {
    label: 'Unknown',
    className: 'bg-gray-100 text-gray-800 border-gray-200',
    pulse: false,
  },
};

export const DataAgentStatusBadge: React.FC<DataAgentStatusBadgeProps> = ({
  status,
  showPulse = true,
}) => {
  const config = statusConfig[status];

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium border ${config.className}`}
    >
      {showPulse && config.pulse && (
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" />
        </span>
      )}
      {!config.pulse && showPulse && (
        <span className={`inline-flex rounded-full h-2 w-2 ${status === 'offline' ? 'bg-red-500' : 'bg-gray-400'}`} />
      )}
      {config.label}
    </span>
  );
};
